export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/bifm.d3a69219.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};